module.exports = __webpack_public_path__ + "img/gift-4.db78a36a.jpg";